import React from 'react'
import { Container} from 'react-bootstrap'
import HomeImages from '../components/HomeImages'
import Border from '../components/Border'
import Shops from '../components/Shops'
import Apartments from '../components/Apartments'
import Info from '../components/Info'
import Contact from '../components/Contact'

const Home = () => {

  return (
    <Container className="homeContainer p-0" fluid>
      <HomeImages/>
        <Border/>
      <Shops/>
        <Border/>
      <Apartments/>
      <Border/>
      <Info/>
        <Border/>
      <Contact/>
    </Container>
  );
};

export default Home;
